snackbar = require('../../../global/elm/snackbar.coffee')

# INDEED PAID SPONSORING OPERATIONS

$( ->
  # Input enable/disable handing

  $(document).on 'change', '.job-indeed-budget-input', () ->
    parentModal = $(this).parents('.indeed-sponsor-modal')
    customInputForm = $(parentModal.get(0)).find '.indeed-custom-input'
    radioSelected = !$(this).find('.indeed-custom-radio').prop('checked')
    customInputForm.attr 'disabled', radioSelected

  $(document).on 'change', '.indeed-custom-input', () ->
    inputValue = $(this).prop 'value'
    parentModal = $(this).parents('.indeed-sponsor-modal')
    customRadioSelect = $(parentModal).find '.indeed-custom-radio'
    customRadioSelect.prop 'value', inputValue

  # Form handling

  $(document).on 'click', '.indeed-sponsor-modal .modal-footer .btn-primary', ->
    the_form =
      if $(this).hasClass('wizard-next')
        step = $(this).closest('.wizard-step').data('step')
        $(this).closest('.modal').find(".modal-body .wizard-step[data-step=#{step}] form")
      else
        $(this).closest('.modal').find("form")

    sponsorAjax(
      the_form.attr('action'),
      if $(this).hasClass('unsponsor')
        { 'job[indeed_sponsored]': false }
      else
        the_form.serialize()
      ,
      if $(this).hasClass('wizard-next')
        ->
          $(".wizard-step[data-step=#{step}]").hide()
          $(".wizard-step[data-step=#{step + 1}]").show()
    )
)

sponsorSuccess = (data) ->
  snackbar(data.result_message) unless data.result_message == ''
  if data.indeed_sponsored == false
    addRemove = ['sponsor', 'sponsored', 'Sponsor']
  else if data.indeed_sponsored == true
    addRemove = ['sponsored', 'sponsor', 'Sponsored']
  $("#sponsor_action_#{data.id}")
    .addClass(addRemove[0])
    .removeClass(addRemove[1])
    .text(addRemove[2])
  if this && {}.toString.call(this) == '[object Function]'
    this()

sponsorError = (data) ->
  if data.responseJSON
    snackbar("Please choose a budget of at least $150.")
  else
    snackbar("There was an error processing your request. Please try again later.")

sponsorAjax = (url, data, fn) ->
  $.ajax(
    {
      url: url
      data: data
      success: sponsorSuccess.bind(fn)
      error: sponsorError
      type: 'PATCH'
    }
 )
